import { BaseModalProps, Button, ModalContentWrapper } from 'ui';
import { CheckBlueIcon } from 'ui/icons';

interface IncidentCreatedModalProps extends BaseModalProps {
  departmentName?: string;
  isCreatedEvent?: boolean;
}

const IncidentCreatedModal = ({
  open,
  onClose,
  departmentName = '',
  isCreatedEvent = true,
}: IncidentCreatedModalProps) => {
  return (
    <ModalContentWrapper
      title=""
      open={open}
      onClose={onClose}
      classes={{ children: '!pt-0 sm:pt-0' }}
    >
      <div className="flex flex-col items-center">
        <div className="flex justify-center items-center w-[96px] h-[96px] bg-sky-100 rounded-full mb-9">
          <img width={36} height={36} src={CheckBlueIcon} alt="ok" />
        </div>
        <p className="text-2xl mb-4 text-center">
          {isCreatedEvent ? (
            <>Your event has been reported to {departmentName}</>
          ) : (
            <>All set! This event is resolved</>
          )}
        </p>
        <p className="text-sm text-neutral-500 mb-10 text-center">
          {isCreatedEvent ? (
            <>They will create follow up tasks and work on resolving it.</>
          ) : (
            <>The resolution form has been submitted, and the status has been updated.</>
          )}
        </p>
        <Button variant="secondary" onClick={onClose}>
          OK, got it
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default IncidentCreatedModal;
